import React from 'react'
import Skeleton from '../../skeletonBase'
import { Block } from '../../crRender'

const DropDownSkeleton = ({ className, isRender }) => {
    return (
        <Block isRender={isRender} className={className}>
            <Skeleton variant="text" width="120px" height="1.2rem" style={{ marginBottom: '10px' }} />
            <Skeleton variant="text" width="100%" height="44px" style={{ marginBottom: '20px' }} />
        </Block>
    )
}

export default DropDownSkeleton